/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import DS from 'ember-data';
import TransactionalMessageModel, { TransactionalMessageChannelType } from 'cio/models/transactional-message';
import DeliveryModel from 'cio/models/delivery';
import config from 'cio/config/environment';
import DeliveryService from 'cio/services/delivery';

interface TransactionalActivityPollArgs {
  message: TransactionalMessageModel;
  onDeliveriesFound: () => unknown;
}

export default class TransactionalActivityPoll extends Component<TransactionalActivityPollArgs> {
  @service store!: DS.Store;
  @service('delivery') deliveryService!: DeliveryService;

  @tracked deliveries?: DeliveryModel[];

  fetchDeliveriesTask = task(async () => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      // fetching both as user can draft a delivery and then send it from deliveries page
      this.deliveries = await this.deliveryService.fetchTransactionalDeliveries(
        this.args.message.id,
        this.args.message.type,
      );

      if (this.deliveries.length > 0) {
        this.args.onDeliveriesFound();
        break;
      }

      await timeout(config.APP.pollingDelay);
    }
  });

  get isEmail() {
    return this.args.message.type === TransactionalMessageChannelType.Email;
  }
}
